export default __webpack_public_path__ + "static/media/76.f51c6bbd.jpg";